import { DocumentRead, DocumentRecordType } from "@/types";
import { Typography } from "@mui/material";
import { FunctionField } from "react-admin";

const RECORD_TYPE_LABELS: Record<DocumentRecordType, string> = {
  [DocumentRecordType.STOPLOSS_CLAIMS]: "Stop-Loss Claim",
  [DocumentRecordType.CLAIMS_ITEMS]: "Claim",
  [DocumentRecordType.CLAIMANTS]: "Claimant",
  [DocumentRecordType.CLIENTS]: "Client",
  [DocumentRecordType.REIMBURSEMENTS]: "Reimbursement",
  [DocumentRecordType.ENDORSEMENTS]: "Endorsement",
  [DocumentRecordType.POLICIES]: "Policy",
  [DocumentRecordType.ATTACHMENT]: "Attachment",
};

interface RecordTypeFieldProps {
  source: string;
  label: string;
}

const RecordTypeField = ({ source, label }: RecordTypeFieldProps) => {
  return (
    <FunctionField
      source={source}
      label={label}
      render={(record: DocumentRead) => {
        if (!record || !record.record_type) return null;

        return <Typography variant="body2">{RECORD_TYPE_LABELS[record.record_type] || record.record_type}</Typography>;
      }}
    />
  );
};

export default RecordTypeField;
